import { type ReactNode } from 'react';

/*
 * Кастомная ошибка с передачей компонента отрисовки в ErrorBoundary
 * @kind helper
 */
export class CustomError extends Error {
    public element: ReactNode;

    constructor(element: ReactNode) {
        super();
        this.element = element;
    }
}
